import {
  IGoldReserve,
  IGoldReserveHistory,
} from '../../types/models/GoldReserve';
import {
  FETCH_GOLD_RESERVE,
  FETCH_GOLD_RESERVE_ERROR,
  FETCH_GOLD_RESERVE_SUCCESS,
  GoldReserveActions,
  SAVE_GOLD_RESERVE,
  SAVE_GOLD_RESERVE_ERROR,
  SAVE_GOLD_RESERVE_SUCCESS,
  FETCH_GOLD_RESERVE_HISTORY,
  FETCH_GOLD_RESERVE_HISTORY_ERROR,
  FETCH_GOLD_RESERVE_HISTORY_SUCCESS,
} from '../../types/actions/GoldReserve.actions';

export interface GoldReserveState {
  data: IGoldReserveHistory | null;
  latest: IGoldReserve | null;
  isLoading: boolean;
  isSaving: boolean;
}

const initialState: GoldReserveState = {
  isSaving: false,
  isLoading: false,
  data: null,
  latest: null,
};

export default (
  state = initialState,
  action: GoldReserveActions,
): GoldReserveState => {
  switch (action.type) {
    case FETCH_GOLD_RESERVE_HISTORY:
    case FETCH_GOLD_RESERVE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_GOLD_RESERVE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSaving: false,
        latest: action.payload,
      };
    }
    case FETCH_GOLD_RESERVE_HISTORY_ERROR:
    case FETCH_GOLD_RESERVE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isSaving: false,
      };
    }
    case FETCH_GOLD_RESERVE_HISTORY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSaving: false,
        data: action.payload,
      };
    }
    case SAVE_GOLD_RESERVE: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case SAVE_GOLD_RESERVE_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        latest: action.payload,
      };
    }
    case SAVE_GOLD_RESERVE_ERROR: {
      return {
        ...state,
        isSaving: false,
      };
    }
    default:
      return state;
  }
};
